export const SITE_BRAND = "وون مووی";

export function documentTitleWithBrand(segmentTitle: string): string {
  return segmentTitle + " | " + SITE_BRAND;
}

export function setDocumentTitle(segmentTitle: string): void {
  document.title = documentTitleWithBrand(segmentTitle);
}
